export default __webpack_public_path__ + "images/a6de865bd6015ccaaabc48660f360969.png";